import { render, staticRenderFns } from "./ScoreTable.vue?vue&type=template&id=fef2ecd0&"
import script from "./ScoreTable.vue?vue&type=script&lang=js&"
export * from "./ScoreTable.vue?vue&type=script&lang=js&"
import style0 from "./ScoreTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fef2ecd0')) {
      api.createRecord('fef2ecd0', component.options)
    } else {
      api.reload('fef2ecd0', component.options)
    }
    module.hot.accept("./ScoreTable.vue?vue&type=template&id=fef2ecd0&", function () {
      api.rerender('fef2ecd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GroupTeams/Common/ScoreTable.vue"
export default component.exports